import { useFormContext } from 'react-hook-form'

import { useSelfAssessmentWizard } from '@/src/domains/self-assessments/components/SelfAssessmentWizard/SelfAssessmentWizard.context'
import {
  SelfAssessmentWizardSchema,
  type SelfAssessmentWizardFormValues,
} from '@/src/domains/self-assessments/components/SelfAssessmentWizard/SelfAssessmentWizard.schema'

import { getSelfAssessmentResult } from './SelfAssessmentWizardResult.utils'

export const useSelfAssessmentWizardResult = () => {
  const { definition } = useSelfAssessmentWizard()
  const { getValues } = useFormContext<SelfAssessmentWizardFormValues>()

  const { answers } = SelfAssessmentWizardSchema.parse(getValues())

  return getSelfAssessmentResult(answers, definition.results)
}
